import { reaction as mobxReaction } from "mobx";
export class Disposer {
    constructor() {
        this.disposers = [];
    }
    reaction(expression, effect, opts) {
        const disposer = mobxReaction(expression, effect, opts);
        this.disposers.push(disposer);
        return disposer;
    }
    dispose() {
        this.disposers.forEach((disposer) => disposer());
        this.disposers = [];
    }
}
